export enum PlanState {
  None = 'none',
  Warning = 'warning',
  Attention = 'attention',
  Locked = 'locked',
}
